/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars,no-useless-escape */

xplenty.directive('noteEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/note-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$q',
        '$timeout',
        'modalService',

        function ($scope, $q, $timeout, modalService) {
          const regex = /<br\s*[\/]?>/gi;
          $scope._description = ($scope.description || '').replace(regex, '\n');

          $scope.save = function () {
            const defer = $q.defer();

            $timeout(function () {
              $scope.description = ($scope._description || '').replace(/\n/g, '<br />');
              modalService.hideModal();
              defer.resolve();
            });

            return {
              $promise: defer.promise,
            };
          };
        },
      ],
    };
  },
]);
